<template>
  <div class="unsubscribe-confirmation" role="presentation">
    <section
      class="unsubscribe-confirmation__dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="unsubscribe-confirmation-title"
    >
      <p id="unsubscribe-confirmation-title">
        {{ unsubscribeConrfirmation.title }}
      </p>
      <div class="unsubscribe-confirmation__actions">
        <button type="button" class="keep-subscription" @click="$emit('cancel')">
          {{ unsubscribeConrfirmation.cancel }}
        </button>
        <button type="button" class="confirm-unsubscribe" @click="$emit('confirm')">
          {{ unsubscribeConrfirmation.confirmation }}
        </button>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  props: {
      unsubscribeConrfirmation: {
      type: Object,
      required: true,
      default: () => ({
        title: 'Are you sure you want to cancel your subscription?',
        confirmation: 'Cancel Subscription',
        cancel: 'Keep Subscription'
      })
    }
  },
};</script>

<style scoped lang="scss">
.unsubscribe-confirmation {
  position: fixed;
  z-index: 1000;
  inset: 0;
  display: flex;
  pointer-events: all;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.65);
}

.unsubscribe-confirmation__dialog {
  width: min(100%, 440px);
  padding: 28px;
  border-radius: 12px;
  background: #ffffff;
  color: #1f1f1f;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);

  p {
    margin: 0 0 24px;
    font-size: 18px;
    line-height: 1.4;
  }
}

.unsubscribe-confirmation__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;

  button {
    min-height: 42px;
    padding: 10px 18px;
    border: 0;
    border-radius: 22px;
    cursor: pointer;
    font: inherit;
  }
}

.keep-subscription {
  background: #e7e7e7;
  color: #1f1f1f;
}

.confirm-unsubscribe {
  background: #c62828;
  color: #ffffff;
}
</style>
